function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#4A4A4A"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M12.456 11.316c-.8 0-1.536.276-2.116.739L6.713 9.79c.108-.486.108-.989 0-1.474L10.34 6.05c.58.462 1.316.738 2.116.738 1.876 0 3.396-1.52 3.396-3.394C15.852 1.52 14.332 0 12.456 0c-1.877 0-3.397 1.52-3.397 3.395 0 .253.028.5.08.737L5.513 6.397c-.58-.463-1.316-.74-2.116-.74C1.521 5.658 0 7.178 0 9.054c0 1.874 1.52 3.394 3.397 3.394.8 0 1.535-.276 2.116-.739l3.626 2.266c-.053.242-.08.489-.08.737 0 1.874 1.52 3.394 3.397 3.394 1.876 0 3.396-1.52 3.396-3.394 0-1.875-1.52-3.395-3.396-3.395z",
  transform: "translate(-1333 -158) translate(1263.822 142) translate(71.03 17) translate(.132)"
}))))));

var SvgShare = function SvgShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share.d9679ba2.svg";
export { ForwardRef as ReactComponent };